// Copyright (c) 2019 Deere & Company

import PropTypes from 'prop-types';
import React from 'react';

export const DropdownPopover = props => (
    <div className="dropdown-popover">
        <ul className="dropdown-menu">
            {Array.isArray( props.children ) ? (
                props.children.map( item => (
                    <li key={item.props.id}>
                        <button
                            type="button"
                            className="btn-link dropdown-item"
                            onClick={props.onMenuItemClick}
                        >
                            {item}
                        </button>
                    </li>
                ) )
            ) : (
                <li>
                    <button type="button" className="btn-link dropdown-item" onClick={props.onMenuItemClick}>
                        {props.children}
                    </button>
                </li>
            )}
        </ul>
    </div>
);

DropdownPopover.propTypes = {
    children: PropTypes.node.isRequired,
    onMenuItemClick: PropTypes.func.isRequired,
};
